import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";

export default function FromResponseModal({ onClose, onCreated }) {
  const [subs, setSubs] = useState([]);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/responses").then(({ data }) => {
      const submitted = data.filter((d) => d.status === "submitted" && d.app_count > 0);
      setSubs(submitted);
      if (submitted[0]) setEmail(submitted[0].email);
    }).catch((e) => toast.error(apiErr(e)));
  }, []);

  const submit = async () => {
    if (!email) { toast.error("Pick a submitted response."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/orchestration/jobs/from-response", { email });
      toast.success(`Job created with ${data.task_total} app task(s).`);
      onCreated();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid="from-response-modal">
      <div className="bg-[var(--parchment)] rounded-xl w-full max-w-md shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="brand-band text-white px-6 py-4 flex items-center justify-between">
          <p className="font-semibold">Generate job from a response</p>
          <button onClick={onClose} className="text-white/80 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-neutral-500">Each Section C application block becomes a provisioning task, with a connector auto-suggested from its access method.</p>
          <div>
            <label className="text-xs font-semibold text-neutral-600">Submitted response</label>
            <select data-testid="from-response-select" value={email} onChange={(e) => setEmail(e.target.value)} className="field-input mt-1">
              {!subs.length && <option value="">No submitted responses with apps</option>}
              {subs.map((s) => <option key={s.email} value={s.email}>{s.email} — {s.app_count} app(s)</option>)}
            </select>
          </div>
          <div className="flex justify-end gap-2">
            <button onClick={onClose} className="btn btn-outline">Cancel</button>
            <button data-testid="from-response-submit" onClick={submit} disabled={busy || !email} className="btn btn-primary">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Generate job"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
